const ICON_URL =
  "https://customer-assets.emergentagent.com/job_iso-compliance-hub-23/artifacts/rf9m7vcm_Vanguard-Beacon-Icon-R04.gif";

export function Logo({ tone = "dark", size = "md" }) {
  // tone "dark" -> light backgrounds (text navy), "light" -> dark backgrounds (text white/cream)
  const textColor = tone === "light" ? "text-brand-cream" : "text-brand-navy";
  const sizeCls = size === "sm" ? "text-base md:text-lg" : "text-lg md:text-xl";
  const iconSize = size === "sm" ? "h-7 w-7 md:h-8 md:w-8" : "h-9 w-9 md:h-10 md:w-10";

  return (
    <div
      className={`flex items-center gap-2.5 font-poppins ${sizeCls} font-semibold tracking-tight ${textColor}`}
      data-testid="vb-logo"
    >
      <img
        src={ICON_URL}
        alt="Vanguard Beacon"
        className={`${iconSize} shrink-0 object-contain`}
        loading="eager"
        decoding="async"
      />
      <span className="leading-none uppercase tracking-[0.04em]">
        Vanguard <span className="font-light opacity-90">Beacon</span>
      </span>
    </div>
  );
}
